import type { LaneDefinition } from "../lane.types";
import type { LaneDependencyRelation, LaneSyncBadge } from "./sync.types";

const BADGE_PRIORITY = {
  orphaned: 4,
  partially_invalid: 3,
  needs_review: 2,
  drift_detected: 1,
  aligned: 0,
} as const;

export function deriveLaneSyncBadges(lanes: LaneDefinition[], relations: LaneDependencyRelation[]): LaneSyncBadge[] {
  return lanes.map((lane) => {
    const laneRelations = relations.filter((relation) => relation.fromLaneId === lane.id || relation.toLaneId === lane.id);
    const highestRelation = laneRelations.reduce<LaneDependencyRelation | null>((highest, relation) => {
      if (!highest) return relation;
      return BADGE_PRIORITY[relation.health] > BADGE_PRIORITY[highest.health] ? relation : highest;
    }, null);

    return {
      laneId: lane.id,
      health: highestRelation?.health ?? "aligned",
      label: highestRelation ? highestRelation.health.replace(/_/g, " ") : "aligned",
      reason: highestRelation?.details ?? null,
    };
  });
}